import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICustomerSites } from '../interfaces/customer-sites';
import { ICustomerSitesFilter } from '../interfaces/customer-sites-filter';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { MessageService } from 'primeng';

@Injectable({ providedIn: 'root' })
export class CustomerSitesService extends ReadService<ICustomerSites, ICustomerSitesFilter> {
  url = '/api/customersites';
  entityTitle = 'Customer Sites';

  constructor(
    http: HttpClient,
    handlersFactory: HttpResponsesHandlersFactory,
    private messageService: MessageService,
  ) {
    super(http, handlersFactory);
  }

  saveSites(customerSites: any, isNew: boolean): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });

    return this.handleRequest(
      this.http.post(this.url + '/saveSites', customerSites, { headers: headers }),
      null,
    );
  }

  DeleteSites(id): Promise<any> {
    return this.handleRequest(
      this.http.get(this.url + '/deleteSites?Id=' + id),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }

  getSuggestedCustomerDropOffLocations(originAddress: any): Promise<any> {
    return this.http
      .post(this.url + '/getNearestCustomerSitesToAddress', originAddress)
      .toPromise();
  }

  getSavedSitesForAutoCompletion(
    searchTerm: string,
    customerId?: number,
  ): Promise<ICustomerSites[]> {
    return this.http
      .get<ICustomerSites[]>(
        this.url +
          `/getSavedSitesForAutoCompletion?searchTerm=${encodeURIComponent(
            searchTerm,
          )}&customerId=${customerId ? customerId : 0}`,
      )
      .toPromise();
  }

  getSite(siteId: number): Promise<ICustomerSites> {
    return this.http.get<ICustomerSites>(this.url + `/getSite/${siteId}`).toPromise();
  }

  getSiteByPostcode(postcode: string): Promise<ICustomerSites> {
    return this.http
      .get<ICustomerSites>(this.url + `/getSiteByPostcode?postcode=${encodeURIComponent(postcode)}`)
      .toPromise();
  }

  formatSiteAddress(site: ICustomerSites): string {
    const addressParts = [];

    if (site.siteName) {
      addressParts.push(site.siteName);
    }

    if (site.businessName) {
      addressParts.push(site.businessName);
    }

    if (site.address1) {
      addressParts.push(site.address1);
    }

    if (site.city) {
      addressParts.push(site.city);
    }

    if (site.postcode) {
      addressParts.push(site.postcode);
    }

    return addressParts.join(', ');
  }
}
